import React, { useRef, useState } from "react";
import { useClickOutsideAlerter } from "./useClickOutsideAlerter";

export interface DropdownState {
  isDropdownOpen: boolean;
  setIsDropdownOpen: (isOpen: boolean) => void;
  dropdownContainerRef: React.RefObject<HTMLDivElement>;
}

export const useDropdown = (): DropdownState  => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownContainerRef = useRef(null);
  useClickOutsideAlerter(dropdownContainerRef, () => setIsDropdownOpen(false));

  return {
    isDropdownOpen,
    setIsDropdownOpen,
    dropdownContainerRef
  };
};